
import { sortBy } from 'lodash'
// import cnaes from './cache/cnaes'
import portes from './cache/portes'
import embalagens from './cache/embalagens'
import bancos from './cache/bancos'
import estados from './cache/estados'
import segmentos from './cache/segmentos'
import cidadesBahia from './cache/cidadesBahia'
import tiposVeiculo from './cache/tiposVeiculo'
import tiposCarroceria from './cache/tiposCarroceria'
import freteStatus from './cache/freteStatus'
import estadosCivil from './cache/estadosCivil'
import tiposPessoa from './cache/tiposPessoa'
import tiposNegocioCliente from './cache/tiposNegocioCliente'

export default {
  Usuario: {
    id: null,
    nome: '',
    cargo: '',
    cpf: '',
    email: '',
    telefone: '',
    celular: '',
    perfil: '',
    ativo: null,
    whatsapp: null,
    embarcador: null
  },
  Embarcador: {
    id: 1,
    razaoSocial: '',
    nomeFantasia: '',
    cnpj: '',
    ie: '',
    dataAbertura: '',
    cep: '',
    logradouro: '',
    numero: '',
    complemento: '',
    bairro: '',
    municipio: { id: null },
    estado: 29,
    pais: 'Brasil',
    cnaes: [],
    segmento: { id: null },
    porte: { id: null },
    banco: { id: null },
    agencia: '',
    conta: '',
    colaboradores: [],
    parceiros: []
  },
  Estados: sortBy(estados, ['nome']),
  Cidades: { 29: cidadesBahia },
  Cnaes: null,
  EstadosCivil: estadosCivil,
  Segmentos: segmentos,
  Portes: portes,
  Embalagens: embalagens,
  TiposPessoa: tiposPessoa,
  Bancos: bancos,
  Perfis: [
    { id: 'G', nome: 'Gestor' },
    { id: 'O', nome: 'Operacional' },
    { id: 'A', nome: 'Gestor' }
  ],
  TiposVeiculo: tiposVeiculo,
  TiposCarroceria: tiposCarroceria,
  FreteStatus: freteStatus,
  TotalFretesRascunho: 0,
  TiposNegocioCliente: tiposNegocioCliente,
  Auth: {
    login: {
      expired: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/state.js